import ResultForm from './ResultForm'
export default ResultForm
